import { z } from "zod";

import { AppUserRole } from "../types/roles";
import { fullTrim } from "./helper";

export const loginIdSchema = z
  .string()
  .nonempty("ログインIDは必須です")
  .min(3, "ログインIDは3文字以上で入力してください")
  .max(32, "ログインIDは32文字以内で入力してください")
  .regex(/^[a-zA-Z0-9._-]+$/, "ログインIDは半角英数字と -_. のみ使用できます。")
  .transform((val) => fullTrim(val));

export const passwordSchema = z
  .string()
  .nonempty("パスワードは必須です")
  .min(8, "パスワードは8文字以上で入力してください")
  .max(20, "パスワードは20文字以内で入力してください")
  .regex(/^[a-zA-Z0-9._-]+$/, "パスワードは半角英数字と -_. のみ使用できます。")
  .transform((val) => fullTrim(val));

export const userNameSchema = z
  .string()
  .nonempty("ユーザー名は必須です")
  .min(3, "ユーザー名は3文字以上で入力してください")
  .max(50, "ユーザー名は50文字以内で入力してください")
  .transform((val) => fullTrim(val));

export const emailSchema = z
  .string()
  .nonempty("メールアドレスは必須です")
  .email("正しいメールアドレスを入力してください")
  .transform((val) => fullTrim(val));

export const roleSchema = z.enum(
  Object.values(AppUserRole) as [string, ...string[]],
  {
    required_error: "ロールを選択してください",
  }
);

export const UpdateAccountSchema = z.object({
  email: emailSchema.optional(),
  userName: userNameSchema,
});

export type UpdateAccountInputType = z.infer<typeof UpdateAccountSchema>;
